import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SearchService } from '@boma/supplier-portal/shared/services';
import { IPaginatedResponse } from '@boma/website/shared/entities';
import { IProduct } from 'libs/supplier-portal/shared/entities/src/lib/shared-entities';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'boma-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.scss'],
})
export class ProductSearchComponent implements OnInit {
  @Input() entityId: string = null;
  @Input() entityLocation: string = null;
  @Input() canCreateNewProduct = false;
  @Input() title = 'Product Search';
  @Output() productSelected = new EventEmitter();

  query = '';
  page = '1';
  perPage = '150';
  isSearching = false;
  searchResponse: IPaginatedResponse<IProduct>;
  searchSubscription: Subscription;

  autoCompleteText: string = null;
  autoCompleteSubject = new Subject<string>();
  autoCompleteResults$: Observable<string[]>;

  productSearchSubject = new Subject<string>();
  selectedProduct: IProduct = null;

  productSearchResults: any[];
  productSearchPlaceholder = 'Search All Products';

  selectedSearchCategory = null;
  searchCategories: { label: string; value: string | null }[] = [
    { label: 'All', value: null },
  ];

  constructor(private searchService: SearchService) {}

  ngOnInit(): void {
    // this.searchService
    //   .searchProducts(this.entityId, this.query, this.page, this.perPage)
    //   .subscribe((res) => (this.productSearchResults = res.items));

    this.productSearchSubject
      .asObservable()
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchterm) => {
          this.selectedProduct = null;
          this.isSearching = true;
          return this.searchService.searchProducts(this.entityId, searchterm);
        })
      )
      .subscribe((res) => {
        this.isSearching = false;
        this.productSearchResults = res.items;
        if (res.items.length === 0 && this.canCreateNewProduct) {
          this.productSearchResults.push({
            name: 'No products found, create New Product',
          });
        }
      });

    this.autoCompleteResults$ = this.autoCompleteSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),

      switchMap((searchTerm) => {
        return this.searchService.getSuggestions(
          searchTerm,
          this.selectedSearchCategory,
          this.entityLocation,
          this.entityId
        );
      })
    );
  }

  onSearchQueryChanged(ev) {
    this.productSearchSubject.next(ev.query);
  }

  onProductSelected(ev) {
    this.productSelected.emit(ev);
  }

  onSearch(ev) {
    if ((ev && ev.keyCode === 13) || (typeof ev === typeof '' && ev.length)) {
      //console.log('time to search');
      this.reset();
      this.query = this.autoCompleteText;
    }
  }

  private reset() {
    this.query = null;
    this.page = null;
    this.perPage = null;
  }
}
